import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SecurityGroupGuardService } from './security-group-guard.service';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [],
  providers: [
    SecurityGroupGuardService
  ]
})
export class NavigationGuardModule { }
